module.exports = __webpack_public_path__ + "img/banner@bg.abf821fc.jpg";